import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { API_URL, errMsg, fmtH, hoursBetween, todayPL } from './shared';
import { ConflictWarning, PlacePicker } from './PlacePicker';

export const ManualEntryDialog = ({ workers, onClose, onSaved, initialWorkerId = '', initialDate }) => {
  const [f, setF] = useState({ worker_id: initialWorkerId, date: initialDate || todayPL(), start: '07:00', end: '15:00', break_min: 0, note: '' });
  const [place, setPlace] = useState({ project_id: null, category: null });
  const [conflicts, setConflicts] = useState([]);
  const [saving, setSaving] = useState(false);
  const body = { ...f, break_min: Number(f.break_min) || 0, ...place };
  const hours = hoursBetween(f.start, f.end, f.break_min);
  const ready = f.worker_id && hours && (place.project_id || place.category);

  useEffect(() => {
    if (!ready) { setConflicts([]); return; }
    axios.post(`${API_URL}/godziny/entries/check`, body).then((r) => setConflicts(r.data.conflicts)).catch(() => setConflicts([]));
  }, [f.worker_id, f.date, f.start, f.end, f.break_min, place.project_id, place.category]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    setSaving(true);
    try {
      await axios.post(`${API_URL}/godziny/entries/manual`, body);
      toast.success('Dodano i zatwierdzono wpis');
      onSaved();
      onClose();
    } catch (e) { toast.error(errMsg(e, 'Błąd zapisu')); } finally { setSaving(false); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[var(--crm-bg-dialog)] border-[var(--crm-border)]" data-testid="manual-entry-dialog">
        <DialogHeader><DialogTitle className="text-[var(--crm-text-primary)]">Dodaj wpis ręcznie</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2">
            <Label>Pracownik</Label>
            <Select value={f.worker_id} onValueChange={(v) => setF({ ...f, worker_id: v })}>
              <SelectTrigger data-testid="manual-worker-select"><SelectValue placeholder="Wybierz pracownika" /></SelectTrigger>
              <SelectContent>{workers.filter((w) => w.aktywny).map((w) => <SelectItem key={w.id} value={w.id}>{w.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><Label>Data</Label><Input type="date" max={todayPL()} value={f.date} onChange={set('date')} data-testid="manual-date-input" /></div>
          <div><Label>Przerwa (min)</Label><Input type="number" min="0" value={f.break_min} onChange={set('break_min')} data-testid="manual-break-input" /></div>
          <div><Label>Od</Label><Input type="time" value={f.start} onChange={set('start')} data-testid="manual-start-input" /></div>
          <div><Label>Do</Label><Input type="time" value={f.end} onChange={set('end')} data-testid="manual-end-input" /></div>
          <div className="col-span-2"><Label>Miejsce pracy</Label><PlacePicker value={place} onChange={setPlace} testid="manual-place" /></div>
          <div className="col-span-2"><Label>Notatka</Label><Textarea value={f.note} onChange={set('note')} rows={2} data-testid="manual-note-input" /></div>
        </div>
        <p className="text-sm text-[var(--crm-text-secondary)]" data-testid="manual-hours-preview">Godziny: <strong>{hours ? fmtH(hours) : '—'}</strong></p>
        <ConflictWarning conflicts={conflicts} testid="manual-conflict-warning" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Anuluj</Button>
          <Button onClick={save} disabled={saving || !ready} className="bg-[#FF6B35] hover:bg-[#e55a2b] text-white" data-testid="manual-save-btn">
            {saving ? 'Zapisywanie...' : 'Zapisz i zatwierdź'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
